import Region from '@/components/region';

export default function AreaTemplate() {
  return <Region />;
}
